
export const DoorState = {
  OPEN: 'OPEN',
  OPENING: 'OPENING',
  CLOSED: 'CLOSED',
  CLOSING: 'CLOSING',
  UNKNOWN: 'UNKNOWN'
};

export interface SlidingDoorState {
  doorState: boolean | undefined,
  doorStateString: string,
  slidingTimerRunning: boolean,
  slidingTimerElapsed: number,
  slidingTimerTimeout: number,
  slidingTimerStartedAt: number,
  stopEnabled: boolean
}
